import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './index.css';
import { queryClient } from './lib/query-client';
import { applyTheme, getTheme } from './lib/theme';

// Tema dipasang SEBELUM React render supaya tidak ada kedipan warna.
applyTheme(getTheme());

const rootEl = document.getElementById('root');
if (rootEl === null) {
  throw new Error('Elemen #root tidak ditemukan di index.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
